// src/Dashboard.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Navbar';
import Clients from './Clients';
import Buy from './Buy';
import Stock from './Stock';
import Transactions from './Transactions';
import Convert from './ConvertPage';
import AddToPure from './AddToPure';
import AddToLangdiWeight from './AddToLangdiWeight';
import AddToCashAmount from './AddToCashAmount';
import SellPureWeight from './SellPureWeight';
import SellLangdiWeight from './SellLangdiWeight';
import SellCashAmount from './SellCashAmount';
import Speed from './Speed';
import Advance from './Advance'; // Import the Advance component

const Dashboard = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/clients" element={<Clients />} />
        <Route path="/buy" element={<Buy />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/convert" element={<Convert />} />
        <Route path="/add-to-pure" element={<AddToPure />} />
        <Route path="/add-to-langdi" element={<AddToLangdiWeight />} />
        <Route path="/add-cash" element={<AddToCashAmount />} />
        {/* Routes for Sell */}
        <Route path="/sell-pure-weight" element={<SellPureWeight />} />
        <Route path="/sell-langdi-weight" element={<SellLangdiWeight />} />
        <Route path="/sell-cash-amount" element={<SellCashAmount />} />
        {/* Route for Speed */}
        <Route path="/speed" element={<Speed />} />
        {/* Route for Advance */}
        <Route path="/advance" element={<Advance />} />
      </Routes>
    </Router>
  );
};

export default Dashboard;
